import { useEffect } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { THEME_ENUM } from 'constants/theme.constant'
import { setMode } from 'store/theme/themeSlice'

function useDarkMode() {
    const mode = useSelector((state) => state.theme.mode)
    const { MODE_DARK, MODE_LIGHT } = THEME_ENUM

    const isEnabled = mode === MODE_DARK

    const dispatch = useDispatch()
    const onModeChange = (mode) => dispatch(setMode(mode))

    useEffect(() => {
        if (window === undefined) {
            return
        }
        const root = window.document.documentElement
        root.classList.remove(isEnabled ? MODE_LIGHT : MODE_DARK)
        root.classList.add(isEnabled ? MODE_DARK : MODE_LIGHT)
        // persist 는 IndexedDB(비동기)라 첫 페인트 전엔 못 읽는다. index.html 의 부팅 스크립트가
        // 이 값을 읽어 React 마운트 전에 <html> 클래스를 맞춘다 → 새로고침 때 라이트로 번쩍이지 않는다.
        try { window.localStorage.setItem('dm_theme_mode', isEnabled ? MODE_DARK : MODE_LIGHT) } catch (_e) { /* 무시 */ }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [isEnabled])

    return [isEnabled, onModeChange]
}

export default useDarkMode
